import { render, staticRenderFns } from "./SettlementReview.vue?vue&type=template&id=833fee72"
import script from "./SettlementReview.vue?vue&type=script&lang=js"
export * from "./SettlementReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('833fee72')) {
      api.createRecord('833fee72', component.options)
    } else {
      api.reload('833fee72', component.options)
    }
    module.hot.accept("./SettlementReview.vue?vue&type=template&id=833fee72", function () {
      api.rerender('833fee72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settlement/SettlementReview.vue"
export default component.exports